var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"fill-height",staticStyle:{"height":"100vh"},attrs:{"blue":"","fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }